import '@mantine/core/styles.css';
import { Landing } from './landing/Landing';
import { Presentation } from './presentation/Presentation';

// Hidden route: /presentation is the investor deck. Nothing on the site links to it.
const isPresentation = () =>
  window.location.pathname.replace(/\/+$/, '').toLowerCase() === '/presentation';

function App() {
  return isPresentation() ? <Presentation /> : <Landing />;
}

export default App;
